import React from 'react';
import MultiSiteManagement from '../components/administration/MultiSiteManagement';

const MultiSitePage: React.FC = () => {
  return <MultiSiteManagement />;
};

export default MultiSitePage;
